import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-card-list gfu-scrollable" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_add_product_to_cart = _resolveComponent("add-product-to-cart")
  const _component_product_card = _resolveComponent("product-card")
  const _component_product_card_list_provider = _resolveComponent("product-card-list-provider")

  return (_openBlock(), _createBlock(_component_product_card_list_provider, { products: $props.products }, {
    default: _withCtx(({ productList, onItemAdded, getAddProductToCartModel }) => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList, (product) => {
          return (_openBlock(), _createElementBlock("li", {
            key: product.productId,
            class: "gfu-card-list__item gfu-3of4 gfu-5of12--s gfu-1of3--m"
          }, [
            _createVNode(_component_product_card, _mergeProps({ ref_for: true }, product, {
              context: "modal",
              "show-abstract": false
            }), {
              action: _withCtx(() => [
                _createVNode(_component_add_product_to_cart, _mergeProps({ ref_for: true }, getAddProductToCartModel(product), { onItemAdded: onItemAdded }), null, 16 /* FULL_PROPS */, ["onItemAdded"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["products"]))
}